import Write from './board/Write';
import Comment from './board/comment/Comment';
import CommentChat from './board/comment/CommentChat';
import CommentSingle from './board/comment/CommentSingle';
import MultiList from './board/MultiList';
import GradeList from './board/GradeList';
import MyBookmark from './board/my/MyBookmark';
import MyComment from './board/my/MyComment';
import MyArticle from './board/my/MyArticle';
import ListFactory from './board/ListFactory';
import ViewFactory from './board/ViewFactory';
import * as namespacer from 'js-namespacer';

const win = window as any;

(function( $, exports ) {
  'use strict';

  namespacer( exports, 'ui.ncCommunity' );
  exports.ui.ncCommunity = {
    List: ListFactory,
    View: ViewFactory,
    Write,
    Comment,
    MyArticle,
    MyComment,
    MyBookmark,
    CommentChat,
    CommentSingle,
    MultiList,
    GradeList,
  };

}( win.jQuery, win ));
